import Request from './baseRequest'

const getUserToken = () => {
  return JSON.parse(localStorage.getItem('auth.currentUser')).token
}

const authConfig = () => ({
  headers: {
    authorization: `Bearer ${getUserToken()}`
  }
})

const baseUrl = () => `${window.config.VUE_APP_BACKEND}/api/transactional-emails`

const _getSummary = params => {
  return Request.get(`${baseUrl()}/summary?${params}`, authConfig())
}

const _getMessages = params => {
  return Request.get(`${baseUrl()}/messages?${params}`, authConfig())
}

const _getMessage = ({ id, params }) => {
  return Request.get(`${baseUrl()}/messages/${id}?${params}`, authConfig())
}

export default {
  getSummary: _getSummary,
  getMessages: _getMessages,
  getMessage: _getMessage
}
